import * as React from "react";

import "./template-download-modal.scss";

import {cs}                      from "@Common/react/chain-services";
import {consumeContext}          from "@Common/react/context";
import {UseState}                from "@Common/react/use-state";
import {ModalService3}           from "@Common/ui-components/modal-service-3/modal-service-3";
import {ButtonSpinner}           from "@Common/ui-components/loading-spinners/button-spinner";
import {Responsive2}             from "@Common/ui-components/responsive-2";
import {downloadArrayBuffer}     from "@Common/utils/browser/download-array-buffer";
import {SocialSharing}           from "../../../customize/steps/customize/social-sharing/social-sharing";

export const templateDownloadModal = ({allowSocialShare, templateDownloadUrl, itemId='', templateId, templateName, next: rootNext}) => cs(
    consumeContext('apis'),
    ["modal", ({}, next) => ModalService3({
        xdQaName: "Template Download Modal",
        rootNext,
        next,
        xToClose: false,
        width: 1000,
    })],
    ["saveReady", ({}, next) => UseState({
        initValue: true,
        next
    })],
    ["loading", ({}, next) => UseState({
        initValue: true,
        next
    })],
    ["responsive", (_, next) => Responsive2({
        translate: (w) => w < 640 ? "mobile" : "desktop",
        next,
    })],
    ["sharing", (modal, next) => next(() => <>
        {SocialSharing({
            getImage: () => templateDownloadUrl || modal.params.templateDownloadUrl,
            showEmulation: !itemId
        })}
    </>)],
    ({apis, loading, saveReady, sharing, modal}) => (
        <div className="template-download-modal-box-s9h">
            <div className={(allowSocialShare || modal.params.allowSocialShare) ? "download-social": "download"}>
                <div className="background">
                    {loading.value && <ButtonSpinner size={128}/>}
                    <img
                        src={templateDownloadUrl || modal.params.templateDownloadUrl}
                        alt={templateName || modal.params.templateName}
                        onLoad={() => {
                            loading.onChange(false);
                        }}
                    />
                </div>
                <div
                    className="close-btn"
                    xd-qa-type="icon"
                    xd-qa-name={"Modal Overlay Close"}
                    onClick={() => {
                        modal.close()
                    }}
                >
                    &times;
                </div>
                <div className="bottom">
                    <div className="details">
                        <div className="name">
                            {templateName || modal.params.templateName}
                        </div>
                        <div className="icons">
                            <a
                                className="icon"
                                xd-qa-type="icon"
                                xd-qa-name="download"
                                onClick={saveReady.value ? async () => {
                                    saveReady.onChange(false);
                                    try {
                                        const response = await fetch(templateDownloadUrl || modal.params.templateDownloadUrl, {
                                            method: "GET",
                                            headers: {}
                                        });
                                        const buffer = await response.arrayBuffer();
                                        downloadArrayBuffer(buffer, {fileName: `${templateName || modal.params.templateName}.jpg`});
                                        saveReady.onChange(true);
                                        if( itemId ) {
                                            await apis.next.templateDownloadLog(templateId || modal.params.templateId, `Customize ${itemId}`);
                                        } else {
                                            await apis.next.templateDownloadLog(templateId || modal.params.templateId, 'Main');
                                        }
                                    } catch (err) {
                                        console.log(err);
                                        saveReady.onChange(true);
                                    }
                                } : ()=>{}}
                            >
                                {saveReady.value ? (
                                    <i className="fa fa-download"/>
                                ) : (
                                    <span><ButtonSpinner spinnerColor="black"/></span>
                                )}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            {(allowSocialShare || modal.params.allowSocialShare) && sharing()}
        </div>
    ),
);
